
import React from 'react'

import { Button, Input, Table } from 'antd'
import {  SearchOutlined } from '@ant-design/icons'
import { EmptyPersonalizado } from './EmptyPersonalizado'
import { Toaster } from 'react-hot-toast'
import useReporteAspiranteExamenPendiente from '../hooks/adminexamen/useReporteAspiranteExamenPendiente'
import { buscar_cantidad_aspirantes } from '../functions/arreglos'
import { URL_ASPIRANTES_PENDIENTES_REALIZAR_EXAMEN } from "../api/url";


const ReporteAspiranteExamenPendiente = () => {

  const { datosReportePendiente, loading, columns, setTextoBuscar, textoBuscar } = useReporteAspiranteExamenPendiente()

  var cantidad_aspirantes = buscar_cantidad_aspirantes( datosReportePendiente );

  // console.log(datosReportePendiente);

  const generarPDFaspirantesPendientes = (aspirantesPendientes) => {

    let formData = new FormData();
    formData.append("aspirantesPendientes", JSON.stringify(aspirantesPendientes));

    fetch(URL_ASPIRANTES_PENDIENTES_REALIZAR_EXAMEN, {
      method: "POST",
      body: formData
    })
    .then(res => res.blob())
    .then(d => {

      let pdf = URL.createObjectURL(d);
      // window.open(pdf, "_blank");
      var anchor = document.createElement("a");
      anchor.download = "ASPIRANTES CON EXÁMENES PENDIENTES";
      anchor.href = pdf;
      anchor.click();

    })
    .catch(() => {
      alert("Ocurrió un error al generar PDF.");
    });

  }


  return (
    <>
      <Button type='primary' onClick={() => { generarPDFaspirantesPendientes(datosReportePendiente) }}>
        Generar PDF
      </Button>

      <Table
        loading = { loading }
        columns = { columns }
        title = { () => (
            <>
              <h1>{ cantidad_aspirantes }</h1>
              <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
            </>
        )}
        rowKey = "indice"
        showSorterTooltip = { false }
        dataSource = { datosReportePendiente }
        locale = {{ emptyText: <EmptyPersonalizado/> }}
      />
      <Toaster/>
    </>
  )
}

export default ReporteAspiranteExamenPendiente
